const SummaryCard = ({ label, value, helper, tone = "default" }) => (
  <article className={`summary-card summary-card-${tone}`}>
    <span className="summary-card-label">{label}</span>
    <strong className="summary-card-value">{value}</strong>
    {helper && <span className="summary-card-helper">{helper}</span>}
  </article>
);

const SummaryCards = ({ children, ariaLabel = "Resumo" }) => (
  <section className="summary-grid" aria-label={ariaLabel}>
    {children}
  </section>
);

export { SummaryCard };
export default SummaryCards;
